import React, {
  useRef,
  useState,
  Suspense,
  lazy,
  useEffect,
  useCallback
} from "react";

import {
  Grid,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Divider,
  Box,
  Tabs,
  Tab,
  Typography,
  ClickAwayListener
} from "@material-ui/core";
import HeaderTitle from "./HeaderTitle";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DirectionsIcon from "@material-ui/icons/Directions";
import DeleteIcon from "@material-ui/icons/Delete";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { useSnackbar } from "notistack";

import { connect, useSelector } from "react-redux";

import ConfirmDialog from "../dialogs/ConfirmDialog";
import ConfirmPasswordDialog from "../dialogs/ConfirmPasswordDialog";
import API from "../../utils/axios";
import DateFnsUtils from "@date-io/date-fns";
import HeaderDate from "./HeaderDate";
import history from "../../utils/history";
import {
  setOptionsExpanded,
  setProjectTabValue
} from "../../store/actions/common";
import {
  setCurrentWindow,
  setShowingRouteId
} from "../../store/actions/project";

import HeaderProjectsMenu from "./HeaderProjectsMenu";
import clsx from "clsx";
import { remCalc, checkIsURL, checkIsFOJW } from "../../utils/helpers";
import OptimizedTooltip from "../common/OptimizedTooltip";
import useProductTour from "../../states/tour/tours/product";
import {
  setExtendableId,
  setExtendableType,
  setExtendableBackTo
} from "../../store/actions/edit";
import { setHoverStop } from "../../store/actions/map";
import UnsavedChangesDialog from "../dialogs/UnsavedChangesDialog";
const ArrowBackIcon = lazy(() => import("@material-ui/icons/ArrowBack"));

const dateFns = new DateFnsUtils();

const useStyles = makeStyles(theme => ({
  projectHeader: {
    height: 80,
    maxHeight: 80,
    padding: theme.spacing(1.125, 2, 1.25, 2.5),
    borderBottom: theme.variables.dividerBorder,
    boxSizing: "border-box"
  },
  projectsMenuWrapper: {
    height: 39
  },
  projectTitleDivider: {
    height: 20,
    margin: theme.spacing(1.25, 0, 0, 0.5)
  },
  projectTitleWrapper: {
    height: 36,
    maxHeight: 36,
    marginBottom: 4,
    width: 320,
    maxWidth: 320,
    marginTop: 3,
    overflow: "hidden"
  },
  projectDate: {
    color: "#808080",
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(16),
    fontWeight: "normal"
  },
  menuItemIcon: {
    minWidth: 40
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(15),
    lineHeight: theme.typography.pxToRem(16),
    fontWeight: "normal"
  },
  errorColor: {
    color: theme.palette.error.main
  },
  tabs: {
    minHeight: theme.spacing(7),
    "& .MuiTabs-flexContainer": {
      alignItems: "stretch",
      height: "100%"
    },
    "& .MuiTabs-indicator": {
      height: "3px",
      background: "transparent",
      display: "flex",
      justifyContent: "center",
      "&:after": {
        content: '""',
        width: "calc(100% - 16px)",
        height: "100%",
        display: "block",
        borderRadius: theme.spacing(0.5, 0.5, 0, 0),
        background: theme.palette.primary.main
      }
    }
  },
  tabsContainer: {
    height: theme.spacing(7),
    boxSizing: "border-box",
    borderBottom: theme.variables.dividerBorder
  },
  tabButton: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: remCalc(15),
    position: "relative",
    textTransform: "none",
    padding: theme.spacing(0.75, 2, 0.75, 1.5),
    borderColor: "transparent",
    marginRight: theme.spacing(1.5),
    color: theme.palette.secondary.main,

    "&:hover": {
      borderColor: "#DDD",
      backgroundColor: "#EEE"
    }
  },
  tabButtonHighlighted: {
    "& .highlight": {
      display: "block",
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: theme.spacing(0.5),
      top: "0",
      left: "0",
      opacity: "0",
      backgroundColor: "rgba(19,41,254, 0.6)",
      transition: "opacity .3s, transform .3s",
      animation: "none",
      animationIterationCount: "3 !important"
    }
  },
  tab: {
    minWidth: 0,
    textTransform: "none",
    height: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(0),
    "&:hover": {
      backgroundColor: "#F4F4F4"
    },
    "& + .projectBody-tab": {
      marginLeft: theme.spacing(1.5)
    },
    "& .MuiTab-wrapper": {
      "& span": {
        display: "inline-flex",
        padding: theme.spacing(0.25, 0.5),
        height: "20px",
        boxSizing: "border-box",
        minWidth: theme.spacing(3),
        margin: theme.spacing(0, 0.75),
        background: "#F4F4F4",
        justifyContent: "center",
        borderRadius: theme.spacing(0.5),
        lineHeight: "1rem",
        border: "1px solid #EAEBF0"
      },
      flexDirection: "row"
    }
  },
  selectedTab: {
    color: theme.palette.primary.main,
    backgroundColor: "#ECEEFF !important",
    borderColor: "#D9DDFF"
  },
  disabledTabContent: {
    opacity: 0.8
  },
  tooltip: {
    maxWidth: 256,
    boxSizing: "border-box",
    padding: theme.spacing(1.25, 1.5),
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "16px",
    marginTop: theme.spacing(0.875)
  },
  statusWrapper: {
    padding: theme.spacing(0.25, 0.75),
    backgroundColor: "#F7F7F7",
    border: "1px solid #EAEBF0",
    display: "inline-block",
    borderRadius: 4,
    fontSize: theme.typography.pxToRem(14),
    marginTop: -4,
    marginLeft: 8
  },
  statusWrapperEditing: {
    borderColor: "#D6DAFF",
    backgroundColor: "#F8F9FF",
    color: "#1329FE"
  },
  moreActionsPaper: {
    width: 248
  },
  /*
  infoTrigger: {
    position: "absolute",
    bottom: -12,
    right: 24,
    display: "flex",
    alignItems: "center"
  },
  autoSaveInfo: {
    "& svg": {
      color: "#808080",
      marginRight: theme.spacing(1)
    }
  },
  viewOnlyInfo: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(0.25, 1),
    borderRadius: theme.spacing(0.5),
    "& p": {
      color: "#fff"
    },
    "& svg": {
      color: "#fff",
      marginRight: theme.spacing(0.5)
    }
  },
   */
  iconButton: {
    "&.MuiIconButton-root:hover": {
      backgroundColor: "#EEE"
    },
    "&.Mui-disabled": {
      "& svg": {
        color: "inherit"
      }
    }
  },
  vehiclesTab: {
    padding: "20.5px 18.5px"
  },
  vehiclesTabText: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(20),
    lineHeight: theme.typography.pxToRem(23),
    color: "#202124",
    paddingLeft: theme.typography.pxToRem(16)
  },
  pointerEventsNone: {
    pointerEvents: "none"
  }
}));

const Header = props => {
  const {
    projectId,
    projectDate,
    projectName,
    setOptionsExpanded,
    setProjectDetails,
    setProjectTabValue,
    vehiclesCount,
    tabValue,
    stopsCount,
    routesCount,
    // projectExpired,
    // projectPublished,
    publishedOnce,
    isPastProject,
    published,
    showingRouteId,
    setShowingRouteId,
    setExtendableType,
    setExtendableId,
    saveDisabled,
    setExtendableBackTo,
    setHoverStop,
    setCurrentWindow
  } = props;

  // General
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const isEditMode = useSelector(state => state.project.status === "optimized");

  // Custom
  const productTour = useProductTour();

  // States
  const [menuOpen, setMenuOpen] = useState(false);
  const [dialogDeleteConfirmOpen, setDialogDeleteConfirmOpen] = useState(false);
  const [dialogPasswordOpen, setDialogPasswordOpen] = useState(false);
  const [deletingProject, setDeletingProject] = useState(false);
  const [routesTooltipOpen, setRoutesTooltipOpen] = useState(false);
  const [changesDialog, setChangesDialog] = useState({ visible: false });
  const [openSection, setOpenSection] = useState(null);

  // Effects
  useEffect(() => {
    if (routesCount) {
      setProjectTabValue(1);
      setCurrentWindow("Optimized");
    }
  }, [setCurrentWindow, routesCount, setProjectTabValue]);

  // Refs
  const menuIconRef = useRef(null);
  const dateRef = useRef(null);

  // Callback
  const handleClose = useCallback(() => {
    setShowingRouteId("");
    setExtendableType(null);
    setExtendableBackTo(null);
    setExtendableId(null);
    setHoverStop(null);
  }, [
    setExtendableBackTo,
    setExtendableId,
    setExtendableType,
    setHoverStop,
    setShowingRouteId
  ]);

  const openRouteSettings = useCallback(() => {
    handleClose();
    setOptionsExpanded(true);
  }, [handleClose, setOptionsExpanded]);

  const openVehicles = useCallback(() => {
    handleClose();
    setProjectTabValue(2);
  }, [handleClose, setProjectTabValue]);

  const warnOpen = useCallback(
    openFunc => {
      setOpenSection(() => openFunc);
      if (!saveDisabled) {
        setChangesDialog({ visible: true });
      } else {
        openFunc();
      }
    },
    [saveDisabled, setChangesDialog]
  );

  const updateProject = (data, onSuccess, onError) => {
    // If it is not a URL for now it is a valid name for the project .
    const isValidProjectName = !checkIsURL(data.name);

    if (!isValidProjectName) {
      enqueueSnackbar(
        "The project name can not be a link, please write valid name for the project"
      );
      onError();
    }

    const validatedData = {
      name: !isValidProjectName || !data.name ? projectName : data.name,
      date: data.date || dateFns.format(new Date(projectDate), "dd/MM/yyyy")
    };

    const newProjectDetails = validatedData;

    isValidProjectName &&
      API.patch(`/v1/projects/${projectId}`, newProjectDetails)
        .then(() => {
          setProjectDetails(
            newProjectDetails.name,
            new Date(
              dateFns.parse(newProjectDetails.date, "dd/MM/yyyy")
            ).getTime(),
            projectId
          );
          onSuccess();
        })
        .catch(err => {
          console.log(err);
          enqueueSnackbar(`Something went wrong, couldn't update the project.`);
          onError();
        });
  };

  const openMenu = () => {
    if (!menuOpen) {
      setMenuOpen(true);
    }
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const onDeleteProjectClick = () => {
    setDialogDeleteConfirmOpen(true);
    closeMenu();
  };

  const deleteProject = () => {
    setDeletingProject(true);
    API.delete(`/v1/projects/${projectId}`)
      .then(() => {
        enqueueSnackbar(`Project "${projectName}" deleted.`);
        setDeletingProject(false);
        setDialogPasswordOpen(false);
        sessionStorage.removeItem("currentProject");
        history.push("/projects", {
          action: "delete"
        });
      })
      .catch(err => {
        setDeletingProject(false);
        if (err && err.status === 400) {
          enqueueSnackbar(err.data.message);
        } else {
          enqueueSnackbar(`Something went wrong, couldn't delete the project.`);
        }
      });
  };

  const onDeleteProjectConfirmClick = () => {
    setDialogDeleteConfirmOpen(false);
    if (checkIsFOJW()) {
      setDialogPasswordOpen(true);
      return;
    }
    deleteProject();
  };

  const openDate = () => {
    if (dateRef.current) {
      dateRef.current.open();
    }
  };

  const handleRoutesTooltipClose = () => {
    setRoutesTooltipOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue !== 1) {
      setProjectTabValue(newValue);
    } else {
      if (routesCount > 0) {
        setProjectTabValue(newValue);
      } else {
        setRoutesTooltipOpen(true);
      }
    }
  };

  const isNotAllowedToEdit = published || isPastProject;

  return tabValue === 2 ? (
    <>
      <Grid container alignItems="center" className={classes.vehiclesTab}>
        <Suspense fallback={null}>
          <IconButton onClick={() => setProjectTabValue(0)}>
            <ArrowBackIcon
              style={{
                color: "#606165"
              }}
            />
          </IconButton>
        </Suspense>
        <Typography className={classes.vehiclesTabText}>Vehicles</Typography>
      </Grid>
      <Divider style={{ height: "0.75px" }} />
    </>
  ) : (
    <>
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        justify="center"
        className={classes.projectHeader}
      >
        <Grid item xs style={{ maxWidth: 320 }}>
          <Grid
            container
            alignItems="center"
            spacing={1}
            className={classes.projectTitleWrapper}
          >
            {projectDate && (
              <Grid item className={classes.projectsMenuWrapper}>
                <HeaderProjectsMenu />
              </Grid>
            )}
            {projectDate && (
              <Divider
                orientation="vertical"
                flexItem
                className={classes.projectTitleDivider}
              />
            )}
            <Grid
              item
              xs
              // Disable editing in view and completed mode;
              // If is not in edit mode or project is not published yet changes allowed otherwise not allowed to change title and date
              className={clsx(isNotAllowedToEdit && classes.pointerEventsNone)}
            >
              <HeaderTitle
                projectDate={projectDate}
                projectName={projectName}
                updateProject={updateProject}
                openDate={openDate}
                isNotAllowedToEdit={isNotAllowedToEdit}
              />
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid
              item
              xs={!projectDate}
              // Disable editing in view and completed mode;
              className={clsx(isNotAllowedToEdit && classes.pointerEventsNone)}
            >
              <HeaderDate
                projectDate={projectDate}
                updateProject={updateProject}
                ref={dateRef}
                isNotAllowedToEdit={isNotAllowedToEdit}
              />
            </Grid>
            {(publishedOnce || isPastProject) && (
              <Grid item xs>
                <div
                  className={clsx(
                    classes.statusWrapper,
                    isEditMode && classes.statusWrapperEditing
                  )}
                >
                  {projectDate && (
                    <>
                      <Grid container alignItems="center" alignContent="center">
                        {isPastProject && (
                          <OptimizedTooltip
                            classes={{ tooltip: classes.tooltip }}
                            title="This project completed. You cannot 
                            make any changes to it."
                          >
                            <Box display="flex" alignItems="center">
                              <CheckCircleOutlineIcon
                                fontSize="small"
                                style={{ marginRight: 6.5, color: "#606165" }}
                              />
                              Completed
                            </Box>
                          </OptimizedTooltip>
                        )}
                        {!published && !isPastProject && publishedOnce && (
                          <OptimizedTooltip
                            classes={{ tooltip: classes.tooltip }}
                            style={{ color: "#1329FE" }}
                            title="You are currently in edit mode."
                          >
                            <Box display="flex" alignItems="center">
                              <EditOutlinedIcon
                                fontSize="small"
                                style={{ marginRight: 6.5, color: "#1329FE" }}
                              />
                              Editing
                            </Box>
                          </OptimizedTooltip>
                        )}
                        {published && !isPastProject && (
                          <OptimizedTooltip
                            classes={{ tooltip: classes.tooltip }}
                            title="You are currently in view mode. To 
                            make any changes, go to edit project."
                          >
                            <Box display="flex" alignItems="center">
                              <RemoveRedEyeOutlinedIcon
                                fontSize="small"
                                style={{ marginRight: 6.5, color: "#606165" }}
                              />
                              Viewing
                            </Box>
                          </OptimizedTooltip>
                        )}
                      </Grid>
                    </>
                  )}
                </div>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <OptimizedTooltip placement="bottom" title="Vehicles">
            <IconButton
              ref={menuIconRef}
              onClick={() => warnOpen(openVehicles)}
              disabled={!projectDate || productTour.hasActiveTourCurrently()}
              style={{ marginRight: 8 }}
            >
              <Badge
                badgeContent={`${vehiclesCount}`}
                color={vehiclesCount === 0 ? "error" : "secondary"}
              >
                <LocalShippingIcon />
              </Badge>
            </IconButton>
          </OptimizedTooltip>
        </Grid>
        <Grid item>
          <OptimizedTooltip placement="bottom" title="More">
            <IconButton
              data-id="project_more_btn"
              ref={menuIconRef}
              onClick={openMenu}
              disabled={!projectDate || productTour.hasActiveTourCurrently()}
            >
              <MoreVertIcon />
            </IconButton>
          </OptimizedTooltip>
        </Grid>
      </Grid>
      {(tabValue === 0 || !showingRouteId) && (
        <Box className={classes.tabs}>
          <Box
            className={classes.tabsContainer}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            py={2}
            px={3}
          >
            <Box display="flex" alignItems="center">
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                className={classes.tabs}
                indicatorColor="primary"
              >
                <Tab
                  className={clsx(classes.tab, "projectBody-tab")}
                  data-id="project_stop_tab"
                  value={0}
                  disabled={!projectDate}
                  label={
                    <>
                      Stops
                      <span>{stopsCount}</span>
                    </>
                  }
                />
                <Tab
                  className={clsx(classes.tab, "projectBody-tab")}
                  disabled={!projectDate}
                  data-id="project_routes_tab"
                  value={1}
                  label={
                    <OptimizedTooltip
                      title="First plan some routes."
                      placement="bottom"
                      classes={{ tooltip: classes.tooltip }}
                      open={routesTooltipOpen}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      onClose={handleRoutesTooltipClose}
                    >
                      <Box>
                        <ClickAwayListener
                          onClickAway={handleRoutesTooltipClose}
                        >
                          <Box
                            className={clsx(
                              routesCount === 0 && classes.disabledTabContent
                            )}
                          >
                            <Box>
                              Routes
                              <span>{routesCount}</span>
                            </Box>
                          </Box>
                        </ClickAwayListener>
                      </Box>
                    </OptimizedTooltip>
                  }
                />
              </Tabs>
            </Box>
          </Box>
        </Box>
      )}
      <Menu
        id="project_more_actions_menu"
        anchorEl={menuIconRef.current}
        keepMounted
        open={menuOpen}
        onClose={closeMenu}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        classes={{
          paper: classes.moreActionsPaper
        }}
      >
        <MenuItem
          onClick={() => {
            closeMenu();
            warnOpen(openRouteSettings);
          }}
          data-id="route_settings_btn"
        >
          <ListItemIcon className={classes.menuItemIcon}>
            <DirectionsIcon />
          </ListItemIcon>
          <ListItemText
            className={classes.menuItemText}
            disableTypography
            primary="Routing settings"
          />
        </MenuItem>
        <MenuItem
          onClick={onDeleteProjectClick}
          className={classes.errorColor}
          data-id="project_delete_btn"
        >
          <ListItemIcon className={classes.menuItemIcon}>
            <DeleteIcon color="error" />
          </ListItemIcon>
          <ListItemText
            className={classes.menuItemText}
            disableTypography
            primary="Delete project"
          />
        </MenuItem>
      </Menu>
      <ConfirmDialog
        open={dialogDeleteConfirmOpen}
        handleClose={() => {
          setDialogDeleteConfirmOpen(false);
        }}
        action={onDeleteProjectConfirmClick}
        title="Delete project?"
        body="This will permanently delete this project. You will not be able to recover the data once deleted."
        isProject={true}
        actionDisabled={deletingProject}
        cancelDisabled={deletingProject}
        disableBackdropClick={deletingProject}
      />
      <ConfirmPasswordDialog
        open={dialogPasswordOpen}
        handleClose={() => {
          setDialogPasswordOpen(false);
          setDeletingProject(false);
        }}
        onConfirm={deleteProject}
      />
      {/* TODO: this part should be moved to project header */}
      {/* {publishedOnce &&
          !projectExpired &&
          currentWindow === "Optimized" &&
          (!projectPublished ? (
            <OptimizedTooltip
              title="Any changes you make to a project that has already been published are immediately visible to your drivers."
              classes={{ tooltip: classes.tooltip }}
              placement="bottom-end"
            >
              <Box className={clsx(classes.infoTrigger, classes.autoSaveInfo)}>
                <InfoOutlinedIcon fontSize="small" />{" "}
                <Typography
                  variant="body2"
                  color="secondary"
                  id="projectEdit-autoSaveText"
                >
                  Auto-saving changes
                </Typography>
              </Box>
            </OptimizedTooltip>
          ) : (
            <OptimizedTooltip
              title="You are only allowed to view this project. To edit, go to the edit project page."
              classes={{ tooltip: classes.tooltip }}
              placement="bottom-end"
            >
              <Box className={clsx(classes.infoTrigger, classes.viewOnlyInfo)}>
                <RemoveRedEyeIcon fontSize="small" />{" "}
                <Typography
                  variant="body2"
                  color="secondary"
                  id="projectDetails-viewOnlyText"
                >
                  View only
                </Typography>
              </Box>
            </OptimizedTooltip>
          ))} */}
      <UnsavedChangesDialog
        open={changesDialog.visible}
        action={() => openSection()}
        handleClose={() => setChangesDialog({ visible: false })}
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    saveDisabled: state.extendable.saveDisabled,
    vehiclesCount: state.project.selectedVehicles.length,
    tabValue: state.common.projectTabValue,
    published: ["published", "expired", "finished"].includes(
      state.project.status.toLowerCase()
    ),
    isPastProject:
      ["expired", "finished"].includes(state.project.status.toLowerCase()) ||
      (state.project.solution?.routes.length &&
        state.project.solution?.routes.every(
          route => route.stops[route.stops.length - 1].status === "finished"
        )),
    showingRouteId: state.project.showingRouteId
  };
}

export default connect(mapStateToProps, {
  setProjectTabValue,
  setOptionsExpanded,
  setShowingRouteId,
  setExtendableType,
  setExtendableId,
  setExtendableBackTo,
  setHoverStop,
  setCurrentWindow
})(Header);
